import { getEmptyQuestion } from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/PhoneConfigurations/PhoneSurveyConfiguration/utils/helpers';
import type { PhoneSurveyConfigurationModel } from '~/server_shared/openapi/data-contracts';

export const getInitialValues = (configuration?: PhoneSurveyConfigurationModel): PhoneSurveyConfigurationModel => {
  if (!configuration?.id) {
    return {
      welcome_message_configuration: {
        configuration_type: 'text_message',
        message_text: '',
        stored_file_id: null,
      },
      response_line_configuration: {
        configuration_type: 'text_message',
        message_text: '',
        stored_file_id: null,
      },
      illegal_response_text_configuration: {
        configuration_type: 'text_message',
        message_text: '',
        stored_file_id: null,
      },
      ending_message_configuration: {
        configuration_type: 'text_message',
        message_text: '',
        stored_file_id: null,
      },
      questions: [getEmptyQuestion()],
    };
  }

  return configuration;
};
